// extracted by mini-css-extract-plugin
export default {"modal":"app-components-CreatePartialPerson-CreatePartialPersonModal-module__KJotZULmnmMm_p2jgtqq"};